import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: {},
      },
      de: {
        translation: {},
      },
      ru: {
        translation: {},
      },
    },
    lng: "de",
    fallbackLng: "de",

    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: "loaded languageChanged",
      bindI18nStore: "added",
      useSuspense: true,
    },
  });

export default i18n;
